import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { FilterCombinationResponse } from '@api-response-types/filter-combination.response';
import { SaveFilterCombinationDto } from '@api-types/dtos/save-filter-combination.dto';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FilterCombinationHttpClient {
  private readonly http = inject(HttpClient);

  getFilterCombinations(configurationId: string) {
    return this.http.get<FilterCombinationResponse[]>(
      `${environment.api.url}/forecasts/${configurationId}/filter-combinations`,
    );
  }

  createFilterCombination(
    filterCombination: SaveFilterCombinationDto,
    configurationId: string,
    resultSetId: string,
  ): Observable<FilterCombinationResponse> {
    return this.http.post<FilterCombinationResponse>(
      `${environment.api.url}/forecasts/${configurationId}/result-set/${resultSetId}/save-filter-combination`,
      filterCombination,
    );
  }

  deleteFilterCombination(
    filterCombinationId: string,
    configurationId: string,
  ): Observable<FilterCombinationResponse[]> {
    return this.http.delete<FilterCombinationResponse[]>(
      `${environment.api.url}/forecasts/${configurationId}/filter-combinations/${filterCombinationId}`,
    );
  }
}
